import Main from "~/ts/Main";
import ThemeOption from "parent/ts/base/Interfaces/ThemeOption";

declare var TheeTheme: ThemeOption;

if (typeof TheeTheme !== undefined) {
    const thee = new Main();

    thee.options = TheeTheme;
}
